import { request, exportCsvData, importData, downloadTemplate } from './api';
import { VariantInterface } from '../types';

const BASE_PATH = `/variants`;

interface SendReqConfig {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  id?: string;
  data?: Partial<VariantInterface>;
  params?: string;
  basePath?: string;
}

export async function sendReq({ method = 'GET', id, data, params = '', basePath }: SendReqConfig = {}): Promise<any> {
  return await request({ method, id, data, params, basePath: BASE_PATH });
}

export async function getVariants(inactive?:boolean,id?:string): Promise<{ data: VariantInterface[] }> {
  let params = `inactive=${inactive}`;
  if(id) params += id ? `&id=${id}` : '';
  const res = await sendReq({params: params});
  return Array.isArray(res.data) ? res.data : {data: [res.data]};
}

export async function createVariant(data: Partial<VariantInterface>): Promise<VariantInterface> {
  return await sendReq({ method: 'POST', data });
}

export async function updateVariant(id: string, data: Partial<VariantInterface>): Promise<VariantInterface> {
  return await sendReq({ method: 'PUT', id, data });
}

export async function deleteVariant(id: string): Promise<void> {
  return await sendReq({ method: 'DELETE', id });
}

export interface PaginatedVariantsResponse {
  data: VariantInterface[];
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

export async function getVariantsByGroup(groupId: string, params?: string, inactive?:boolean): Promise<PaginatedVariantsResponse> {
  let paramString = `group_id=${groupId}${inactive ? '&inactive=true' : ''}`;
  if (params) paramString += `&${params.replace(/^\?/, '')}`;
  return await sendReq({ params: paramString });
}

export async function exportVariantsByGroup(groupId: string, params?: string, inactive?:boolean): Promise<void> {
  let paramString = `group_id=${groupId}${inactive ? '&inactive=true' : ''}`;
  if (params) paramString += `&${params.replace(/^\?/, '')}`;
  return await exportCsvData(BASE_PATH, paramString);
}

export async function importVariants(data: any[]): Promise<any> {
  return await importData(BASE_PATH, data);
}

export async function downloadVariantsTemplate(): Promise<void> {
  return await downloadTemplate(BASE_PATH);
}

export async function createSpecialPrice(id: string, data: any): Promise<any> {
  return await sendReq({ method: 'POST', id, params: 'action=specialprice', data });
}

export async function createPaymentLink(data: any): Promise<{ token: string }> {
  return await sendReq({ method: 'POST', params: 'action=paymentlink', data });
} 